// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_CancelaCompromissoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos_servicos/cancelaCompromissoServico
 *
 * Cancels a compromisso_servico (sets status to CANCELADO) and resets the related
 * orcamento_servico status back to AGUARDANDO_AGENDAMENTO.
 *
 * Data shape: boolean true on success
 *
 * @see Compromissos_servicos::cancelaCompromissoServico()
 * @see Atendente_interactor::CancelaServicoCompromisso()
 * @see Compromissos_servicos_model::cancela_compromisso_servico()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CompromissosServicos_CancelaCompromissoServicoResponseDados = boolean;

export type CompromissosServicos_CancelaCompromissoServicoResponse = ApiResponse<CompromissosServicos_CancelaCompromissoServicoResponseDados>;

registerResponseContract('CompromissosServicos_CancelaCompromissoServicoResponse', {})
